import {
  Button,
  Icon,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { Course } from "../../const/types";
import { Trash } from "@phosphor-icons/react";
import { iconSize } from "../../const/sizes";
import cr from "../../lib/request";
import { useNavigate } from "react-router-dom";

type Props = {
  data: Course;
};

export default function DeleteCourseModal({ data }: Props) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [loading, setLoading] = useState<boolean>(false);
  const toast = useToast();
  const navigate = useNavigate();

  const onDelete = () => {
    setLoading(true);
    const url = `api/course/${data.id}/destroy`;
    cr.delete(url)
      .then((r) => {
        if (r.status === 200) {
          toast({
            title: "Berhasil menghapus course",
            description: r.data.message,
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          navigate("/course/list");
        }
      })
      .catch((e) => {
        console.log(e);
        toast({
          title: "Gagal menghapus course",
          description: e.response.data.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <IconButton
        onClick={onOpen}
        colorScheme="red"
        variant={"ghost"}
        aria-label="deleteKategori"
        className="clicky"
        size={"sm"}
        icon={<Icon as={Trash} fontSize={iconSize} />}
      />

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />

        <ModalContent>
          <ModalHeader>Delete Course</ModalHeader>

          <ModalBody>
            <Text mb={4}>
              Apakah Anda yakin akan menghapus course ini{" "}
              <b>{data.nama_course}</b>
            </Text>
            <Text opacity={0.5} fontSize={"small"}>
              Data course tidak dihapus permanen, course yang telah dihapus
              dapat dikembalikan lagi di menu <b>Restore</b>
            </Text>
          </ModalBody>

          <ModalFooter gap={2}>
            <Button className="btn clicky" onClick={onClose}>
              Batal
            </Button>

            <Button
              colorScheme="red"
              className="clicky"
              onClick={onDelete}
              isLoading={loading}
            >
              Delete
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
